module.exports = __webpack_public_path__ + "static/media/SF-2.5e99bc0c.mp3";